export default "__VITE_ASSET__DHFgetoj__"